export default __webpack_public_path__ + "static/media/rev_f_cab_view.3ed7d4fa.webp";